
import {

  get_BotListGroup,
  get_group_details,
  get_group_token,
  get_group_user_details,
  get_group_user_logs,
} from "./../../helpers/fakebackend_helper";

// action
import {
  fetchGroup_Details_Success,
  fetchGroup_Details_Failed,
  reset_group_details_flag,
  start_group_Deatils_fetch_loading,
  set_Token_Used_By_Group,
  set_Token_Used_By_Group_Failed,
  stop_group_Deatils_fetch_loading,
  set_group_user_details,
  set_group_user_log_loading,
  set_group_user_logs
} from "./reducer";



export const GET_GROUP_USER_DETAILS = (filterData) => async (dispatch) => {
  
  try {
    let response;
         dispatch(start_group_Deatils_fetch_loading())      

      response = get_group_user_details(filterData);
      const data = await response;
      console.log("Data ---->",data);
      
      dispatch(stop_group_Deatils_fetch_loading())  
       
    
        dispatch(set_group_user_details(data));
    
  } catch (error) {
    
    dispatch(fetchGroup_Details_Failed(error));
  }
};



export const GET_GROUP_USER_LOGS = (filterData) => async (dispatch) => {
  
  try {
    let response;
    dispatch(set_group_user_log_loading(true))      

      response = get_group_user_logs(filterData);
      const data = await response;


     dispatch(set_group_user_logs(data));


        dispatch(set_group_user_log_loading(false)) 
    
  } catch (error) {
    dispatch(set_group_user_log_loading(false)) 
  }
};



export const group_owner_details = (filterData) => async (dispatch) => {
  
  try {
    let response;
         dispatch(start_group_Deatils_fetch_loading())      

      response = get_group_details(filterData);
      const data = await response;

       
    
        dispatch(fetchGroup_Details_Success(data));
    
  } catch (error) {
    
    dispatch(fetchGroup_Details_Failed(error));
  }
};


export const fetch_group_token_usages = (filterData) => async (dispatch) => {
  
  try {
    let response;
         dispatch(start_group_Deatils_fetch_loading())      

      response = get_group_token(filterData);
      const data = await response;


    

        dispatch(set_Token_Used_By_Group(data.total_tokens));
    
  } catch (error) {
    
    dispatch(set_Token_Used_By_Group_Failed(error));
  }
};

export const reset_group_Owner = () => {
  try {
    const response = reset_group_details_flag();
    return response;
  } catch (error) {
    return error;
  }
};


